<div class="rounded-t-md p-8" style="border-top-width: 6px !important; border-color: #7fb614;">
  <!-- Header with icon and title -->
  <div class="flex items-center gap-3 mb-6">
    <div class="flex-shrink-0">
      <div class="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
        <mat-icon class="text-amber-500">warning_amber</mat-icon>
      </div>
    </div>
    <div>
      <h1 class="text-2xl font-bold text-gray-900 m-0">Account Access Restricted</h1>
    </div>
  </div>

  <!-- Content -->
  <div mat-dialog-content class="p-0">
    <div class="space-y-4 text-gray-600 leading-relaxed">
      <p class="m-0">
        Your Cantrak account access has been temporarily restricted due to outstanding SaaS subscription fees.
      </p>
      
      <p class="m-0">
        Please settle your pending balance to restore full access. Once payment is confirmed, your account will automatically return to normal operation.
      </p>
      
      <p class="m-0">
        If you have already made payment or believe this is an error, kindly contact our support team.
      </p>
    </div>
  </div>

  <!-- Footer info -->
  <div class="mt-8 pt-6 border-t border-gray-200 flex items-center justify-between text-sm">
    <div *ngIf="accountId" class="text-gray-600">
      <span class="font-medium">Account ID:</span>
      <span class="ml-1">{{accountId}}</span>
    </div>
    <div class="text-gray-600">
      <span class="font-medium">Contact:</span>
      <a [href]="'mailto:' + contactEmail" class="ml-1 hover:underline" style="color: #7fb614;">{{contactEmail}}</a>
    </div>
  </div>
</div>